import React, { useState } from "react";
import ItemModal from "../Modal/ItemModal";

const ItemTable = ({
  formDetailList,
  handleChangeDetail,
  handleDuplicateRow,
  handleRemoveRow,
  formatCurrency,
  showItemModal,
  handleItemClose,
  itemDataList,
  onRowSelectItem,
  handleItemShow,
  whDataList,
  showWarehouseModal,
  handleWarehouseClose,
  handleWarehouseShow,
  onRowSelectWh,
  handleFocus,
  handleBlur,
  disabledRec,
  disabled,
  poDataList,
  handlePOShow,
  onRowSelectItem02,
  setFormDetailList,
}) => {
  console.debug("formDetailList", formDetailList);
  // ถ้าเป็นหน้าใบสั่งซื้อและใบรับสินค้า ให้แสดง Column จำนวนรับ / จำนวนค้างรับ
  const isPurchaseOrderOrReceipt = () => {
    return (
      window.location.pathname === "/purchase-order" ||
      window.location.pathname === "/purchase-receipt"
    );
  };

  // ถ้าเป็นหน้าใบสั่งซื้อและใบรับสินค้า ให้กำหนด Width จำนวนรับ / จำนวนค้างรับ
  const getColumnWidth = () => {
    if (window.location.pathname === "/purchase-order") {
      return "13%";
    } else if (window.location.pathname === "/purchase-receipt") {
      return "21%";
    } else if (window.location.pathname === "/product-receipt") {
      return "10%";
    } else {
      return "21%";
    }
  };

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [newItemName, setNewItemName] = useState("");

  const handleOpenModal = (index, item) => {
    setEditingItem(index);
    setNewItemName(item.itemName || ""); // เซ็ตค่าเริ่มต้น
    setShowEditModal(true);
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
    setEditingItem(null);
    setNewItemName("");
  };

  const handleSaveChanges = () => {
    if (editingItem !== null) {
      handleChangeDetail(editingItem, "itemName", newItemName);
    }
    handleCloseModal();
  };

  const handleCheckboxChange = (index) => {
    setFormDetailList((prevList) => {
      const updatedList = [...prevList];
      const currentItem = updatedList[index];

      const isGift = !currentItem.isGift;

      const originalName = currentItem.itemName.replace(/^FREE\s+/i, "");

      updatedList[index] = {
        ...currentItem,
        isGift,
        itemName: isGift ? `FREE ${originalName}` : originalName,
        realPriceBeforeGift: isGift
          ? currentItem.itemPriceUnit // เก็บราคาก่อนเป็นของแถม
          : currentItem.realPriceBeforeGift, // ใช้ราคาก่อนหน้าที่เก็บไว้
        itemPriceUnit: isGift
          ? "0.00"
          : currentItem.realPriceBeforeGift || currentItem.itemPriceUnit,
        itemTotal: isGift
          ? "0.00"
          : formatCurrency(
              parseFloat(currentItem.itemQty || 0) *
                parseFloat(
                  currentItem.realPriceBeforeGift || currentItem.itemPriceUnit
                )
            ),
      };

      return updatedList;
    });
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title">รายละเอียดสินค้า</h4>
          <button
            type="button"
            className="btn text-white mx-3"
            onClick={handleItemShow}
            style={{
              backgroundColor: "rgb(239, 108, 0)",
              whiteSpace: "nowrap",
              padding: "10px",
              fontSize: "15px",
            }}
            disabled={
              window.location.pathname !== "/product-receipt" ? disabled : false
            }
          >
            <i className="fa fa-plus"></i> เพิ่ม BOM
          </button>
        </div>
        <ItemModal
          formDetailList={formDetailList}
          showItemModal={showItemModal}
          handleItemClose={handleItemClose}
          itemDataList={itemDataList}
          onRowSelectItem={onRowSelectItem}
          onRowSelectItem02={onRowSelectItem02}
        />
        <div className="card-body">
          <div
            className="table-responsive"
            style={{ maxHeight: "500px", overflowY: "auto" }}
          >
            <table
              id="basic-datatables"
              className="table table-striped table-hover"
            >
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" style={{ width: "5%" }}>
                    #
                  </th>
                  <th className="text-center" style={{ width: "15%" }}>
                    รหัสสินค้า
                  </th>
                  <th className="text-left" style={{ width: "55%" }}>
                    ชื่อสินค้า
                  </th>
                  <th className="text-center" style={{ width: "15%" }}>
                    จำนวน
                  </th>
                  <th className="text-center" style={{ width: "10%" }}>
                    หน่วย
                  </th>
                  <th className="text-center" style={{ width: "10%" }}>
                    ลบ
                  </th>
                </tr>
              </thead>
              <tbody>
                {formDetailList.length > 0 ? (
                  formDetailList.map((item, index) => (
                    <tr key={item.itemId || index + 1}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">{item.itemCode || ""}</td>
                      <td className="text-left">{item.itemName || ""}</td>
                      <td className="text-center">
                        <input
                          type="text"
                          className="form-control text-center"
                          value={item.itemQty || ""}
                          onChange={(e) =>
                            handleChangeDetail(index, "itemQty", e.target.value)
                          }
                          onFocus={(e) => handleFocus(index, "itemQty")}
                          onBlur={(e) =>
                            handleBlur(index, "itemQty", e.target.value)
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td className="text-center">
                        <input
                          type="text"
                          className="form-control text-center"
                          value={item.itemUnit || ""}
                          disabled={true}
                        />
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleRemoveRow(index)}
                          disabled={disabled}
                        >
                          ลบ
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <center>
                        <h5>ไม่พบรายการสินค้า</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Modal คลังสินค้า */}
            <div
              className={`modal fade ${showWarehouseModal ? "show" : ""}`}
              style={{ display: showWarehouseModal ? "block" : "none" }}
              tabIndex="-1"
              role="dialog"
            >
              <div
                className="modal-dialog modal-lg"
                style={{ maxWidth: "35%" }}
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <div className="d-flex align-items-center">
                      <h4 className="card-title">คลังสินค้า</h4>
                    </div>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleWarehouseClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "650px", overflowY: "auto" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-dark">
                          <tr>
                            <th
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              รหัสคลังสินค้า
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "80%" }}
                            >
                              ชื่อคลังสินค้า
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {whDataList && whDataList.length > 0 ? (
                            whDataList.map((warehouse, index) => (
                              <tr
                                key={warehouse.Item_Id || index + 1}
                                onClick={() => onRowSelectWh(warehouse)}
                                style={{ cursor: "pointer" }}
                              >
                                <td className="text-center">
                                  {warehouse.WH_Code}
                                </td>
                                <td className="text-left">
                                  {warehouse.WH_Name}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2">
                                <center>
                                  <h5>ไม่พบข้อมูล</h5>
                                </center>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-lg btn-danger"
                      onClick={handleWarehouseClose}
                    >
                      ปิด
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {showEditModal && (
              <div className="modal fade show" style={{ display: "block" }}>
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">แก้ไขชื่อสินค้า</h5>
                      <button
                        className="btn-close"
                        onClick={handleCloseModal}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <textarea
                        className="form-control"
                        value={newItemName}
                        onChange={(e) => setNewItemName(e.target.value)}
                        // maxLength={200}
                        rows={5} // ให้เริ่มต้นเล็กสุด แต่ขยายเมื่อพิมพ์เพิ่ม
                        style={{
                          minHeight: "50px",
                          maxHeight: "300px",
                          resize: "none", // ไม่ให้ผู้ใช้ปรับเอง แต่ขยายอัตโนมัติ
                          overflowY: "hidden",
                          lineHeight: "1.8", // ปรับระยะห่างระหว่างบรรทัด
                          padding: "10px", // เพิ่มพื้นที่ให้พิมพ์ง่ายขึ้น
                          fontSize: "16px", // ให้ตัวหนังสืออ่านง่าย
                        }}
                        onInput={(e) => {
                          e.target.style.height = "auto"; // รีเซ็ตขนาดก่อนคำนวณใหม่
                          e.target.style.height = e.target.scrollHeight + "px"; // ปรับขนาดตามข้อความ
                        }}
                      />
                    </div>
                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={handleCloseModal}
                      >
                        ยกเลิก
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleSaveChanges}
                      >
                        บันทึก
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {showWarehouseModal && (
              <div className="modal-backdrop fade show"></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemTable;
